import React from "react";
import { motion } from "framer-motion";

export default function HeatMeter({ value = 72, label = "Cultural Heat" }) {
  const pct = Math.max(0, Math.min(100, value));
  const hue = pct >= 65 ? "#00FF66" : pct >= 40 ? "#FFD600" : "#FF0055";
  return (
    <div data-testid="heat-meter" className="relative overflow-hidden rounded-3xl glass-strong p-6 grain">
      <div
        aria-hidden
        className="absolute -top-12 -right-12 w-60 h-60 rounded-full opacity-40 heat-pulse"
        style={{ background: `radial-gradient(circle, ${hue}, transparent 70%)` }}
      />
      <div className="flex items-start justify-between">
        <div>
          <p className="text-xs tracking-[0.3em] uppercase font-bold text-white/50">{label}</p>
          <div className="font-display text-5xl md:text-6xl font-bold mt-2" style={{ color: "#fff" }}>
            <motion.span
              key={pct}
              initial={{ opacity: 0, y: 8 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.35 }}
            >
              {pct}
            </motion.span>
            <span className="text-lg text-white/40 ml-1 align-top">/100</span>
          </div>
          <p className="mt-2 text-sm text-white/60">
            {pct >= 80 ? "Scorching — the culture is on fire." :
              pct >= 60 ? "Heating up — trends rising." :
              pct >= 40 ? "Simmering — picks are stabilizing." :
              "Chilling — hidden gems opportunity."}
          </p>
        </div>
        <div className="chip" style={{ background: `${hue}22`, color: hue, border: `1px solid ${hue}55` }}>
          Live
        </div>
      </div>
      <div className="mt-6 h-3 w-full rounded-full bg-white/5 overflow-hidden">
        <motion.div
          initial={{ width: 0 }}
          animate={{ width: `${pct}%` }}
          transition={{ duration: 1, ease: "easeOut" }}
          className="h-full rounded-full"
          style={{ background: `linear-gradient(90deg, #FF0055, ${hue})`, boxShadow: `0 0 24px ${hue}55` }}
        />
      </div>
    </div>
  );
}
